"use client";

import { motion } from "motion/react";
import type { ReactNode } from "react";

// A section fades and lifts into place the first time it scrolls into view. `once: true` so it
// doesn't re-trigger on scroll-up -- a subtle entrance, not a distraction on every pass.
export default function Reveal({
  children,
  delay = 0,
  className,
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
